export class AirtimeManagementToken {
  static IAirTimeManagementRepository = Symbol("IAirTimeManagementRepository");
  static AirTimeManagementViewModel = Symbol("AirTimeManagementViewModel");
  static AirtimeManagementUseCase = Symbol("AirtimeManagementUseCase"); 
}
